const unit = {
  kg: 'Kg'
}

export default unit
